import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getBookingsById = async id => {
  const { data, error } = await supabase
    .from('booking_transactions')
    .select(`*, team_id(*), service(*, menu_category(*)), services(salons_profile(*))`)
    .eq('id', id)
    .in('status', ['Pending', 'Paid', 'Completed', 'Booked'])
    .maybeSingle();

  if (error) {
    throw new Error(`Error fetching bookings: ${error.message}`);
  }

  return data;
};

export default function useGetBookingsById(id) {
  return useQuery({
    queryKey: ['useGetBookingsById', id],
    queryFn: () => getBookingsById(id),
    staleTime: 0,
    enabled: !!id,
  });
}
